export default __webpack_public_path__ + "static/media/logo-dollarsetcents.60632dce.png";